export default __webpack_public_path__ + "static/media/ROM CLASS-10_SYLLABUS_2025-26.018f7338.pdf";